import { render, staticRenderFns } from "./B102.vue?vue&type=template&id=f080e8a6&scoped=true"
import script from "./B102.vue?vue&type=script&lang=js"
export * from "./B102.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Pdis.css?vue&type=style&index=0&id=f080e8a6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f080e8a6",
  null
  
)

export default component.exports